import React from 'react';

const AppleAuthButton = ({ handleClick }) => (
  <button type="button" className="auth-btn apple" onClick={handleClick}>
    Sign in with Apple
  </button>
);

export default AppleAuthButton;
